import React, { CSSProperties } from 'react';
import { IEHSImage } from 'utils/types';

import * as S from './styles';

export interface ISolutionsHero {
  title?: string;
  headline: string;
  description?: string;
  cta?: {
    text: string;
    url: string;
  };
  desktopImage?: IEHSImage;
  backgroundColor?: string;
  titleStyle?: CSSProperties;
  headlineStyle?: CSSProperties;
}

const Hero: React.FC<ISolutionsHero> = (props) => {
  const {
    title,
    headline,
    description,
    cta,
    desktopImage,
    backgroundColor,
    titleStyle,
    headlineStyle,
  } = props;

  return (
    <S.HeroWrapper data-testid="solutionsHero">
      <S.HeroTop $backgroundColor={backgroundColor}>
        <S.HeroInner>
          <S.Content>
            {title ? <S.Title style={titleStyle}>{title}</S.Title> : null}
            <S.Headline style={headlineStyle}>{headline}</S.Headline>
          </S.Content>
        </S.HeroInner>
      </S.HeroTop>
      {desktopImage ? (
        <S.ImageWrapper>
          <S.Image
            image={desktopImage.gatsbyImageData}
            alt={desktopImage.title}
          />
        </S.ImageWrapper>
      ) : null}
      <S.HeroBottom>
        <S.HeroInner>
          <S.Content>
            <S.Description>{description}</S.Description>
            {cta ? (
              <S.CTA href={cta?.url} appearance="primary">
                {cta?.text}
              </S.CTA>
            ) : null}
          </S.Content>
        </S.HeroInner>
      </S.HeroBottom>
    </S.HeroWrapper>
  );
};

export default Hero;
